import React, { useEffect, useState } from "react";
import { Box, Paper, Pagination, Typography, CircularProgress } from "@mui/material";
import ApiService from "../../functions/apiService";
import ArrowLeft from "../../components/Calendar/ArrowLeft";
import ArrowRight from "../../components/Calendar/ArrowRight";
import moment from "moment";
import MyTable from "../../components/Schedule/MyTable";
import { useSearchParams } from 'react-router-dom';
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function UserMessages() {
  const [loading, setLoading] = useState(false)
  const [messages, setMessages] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const [searchParams, setSearchParams] = useSearchParams();
  const routeDate = searchParams.get('date') || moment().format('YYYY-MM-DD');
  let navigate = useNavigate();

  const getMessages = (date = null) => {
    var tempDate = routeDate
    if (date) {
      tempDate = date
    }
    setLoading(true)
    ApiService.get(`/getMyMessages?page=${currentPage}&limit=${itemsPerPage}&date=${tempDate}`)
      .then(({ data }) => {
        setMessages(data?.data?.data);
        setTotalPages(Math.ceil(data?.data?.total / data?.data?.per_page));
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  const handlePageChange = (_, value) => {
    setCurrentPage(value);
  };

  let ChangeDateByArrow = (days) => {
    setSearchParams({ date: moment(routeDate, 'YYYY-MM-DD').add(days, 'days').format('YYYY-MM-DD') })
    getMessages(moment(routeDate, 'YYYY-MM-DD').add(days, 'days').format('YYYY-MM-DD'))
  }

  useEffect(() => {
    getMessages()
  }, [currentPage])

  const columns = [
    {
      field: 'time', headerName: 'Timestamp', flex: 1, minWidth: 100, maxWidth: 150, valueGetter: (params) => moment(params?.row?.Log_Time).format('MM/DD/YYYY')
    },
    {
      field: 'type', headerName: 'Type', flex: 1, minWidth: 100, maxWidth: 130, valueGetter: (params) => params?.row?.Log_Type,
    },
    {
      field: 'sent', headerName: 'Sent by', flex: 1, minWidth: 100, maxWidth: 250, valueGetter: (params) => params?.row?.log_by_emp?.fullName
    },
    {
      field: 'message', headerName: 'Message', flex: 1, minWidth: 180, valueGetter: (params) => params?.row?.Log_Text
    },
  ]

  return (
    <>
      <Paper className="p-3" style={{ marginTop: "1rem" }}>
        <Row>
          <Col md={9} sm={10} xs={10} style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '200px' }} className={'tab-white'}
              onClick={() => navigate("/firehouse/messaging")}>
              Send A Message
            </div>
            <div style={{ width: '190px' }} className={'tab-active mx-2'}>
              User Messages
            </div>
          </Col>
        </Row>
        <Typography variant="h6" className="mb-2 mt-4">User Messages</Typography>
        <Typography style={{ fontSize: '13px' }}>
          <div>
            <button className='border-0 bg-transparent' onClick={() => ChangeDateByArrow(-1)}>
              <ArrowLeft />
            </button>
            {moment(routeDate).format("dddd Do MMMM YYYY")} - Group 1
            <button className='border-0 bg-transparent' onClick={() => ChangeDateByArrow(1)}>
              <ArrowRight />
            </button>
            <img src='/images/refresh.png' style={{ width: 20, cursor: 'pointer' }} onClick={() => getMessages()} />
          </div>
        </Typography>
        {loading ?
          <Paper className="w-100 d-flex justify-content-center align-items-center font-fam" style={{ height: '460px' }}>
            <CircularProgress />
          </Paper>
          :
          <div className='mt-4'>
            <MyTable
              rows={messages}
              columns={columns}
              checkboxSelection={false}
              hideFooter={true}
            />
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              className="mt-4 d-flex"
              style={{ justifyContent: 'end' }}
            />
          </div>
        }
      </Paper>
    </>
  );
}